import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { FaEdit, FaTrash } from "react-icons/fa";
import { useDeleteItem } from "../../_helper/actions/mutation/items";
import { ApiEndPoint } from "../../_helper/constant/api-types";
import { toast } from "react-toastify";
import CuSpinner from "../../common_component/component/CuSpinner";

const LocationTable = ({ locations }) => {
  const navigate = useNavigate();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [locationToDelete, setLocationToDelete] = useState(null);

  const mutation = useDeleteItem(ApiEndPoint.PHARMACY);

  // Handle navigation
  const handleNavigation = (id) => {
    navigate(`/new/setup/rack-management/${id}`);
  };

  // Handle delete confirmation
  const handleDeleteClick = (location) => {
    setLocationToDelete(location);
    setIsModalOpen(true);
  };

  const confirmDelete = () => {
    mutation.mutate(
      {
        data: { action: "delPharmacy", id: locationToDelete.id },
      },
      {
        onSuccess: () => {
          setIsModalOpen(false);
          setLocationToDelete(null);
          toast.success(`Deleting ${locationToDelete.pharmacy_name}`);
        },
      }
    );
  };

  const closeModal = () => {
    setIsModalOpen(false);
    setLocationToDelete(null);
  };

  return (
    <div className="overflow-x-auto bg-white rounded shadow">
      <table className="w-full table-auto">
        <thead>
          <tr className="bg-gray-200">
            <th className="px-6 py-3 text-left font-semibold text-gray-600">
              Pharmacy Name
            </th>
            <th className="px-6 py-3 text-left font-semibold text-gray-600">
              Type
            </th>
            <th className="px-6 py-3 text-left font-semibold text-gray-600">
              City
            </th>
            <th className="px-6 py-3 text-left font-semibold text-gray-600">
              Actions
            </th>
          </tr>
        </thead>
        <tbody>
          {locations?.map((location) => (
            <tr
              key={location.id}
              className="border-b hover:bg-gray-100 transition"
            >
              <td
                className="px-6 py-4 text-blue-500 hover:underline cursor-pointer"
                onClick={() => handleNavigation(location.id)}
              >
                {location.pharmacy_name}
              </td>
              <td className="px-6 py-4 text-gray-700">{location.type}</td>
              <td className="px-6 py-4 text-gray-700">{location.city}</td>
              <td className="px-6 py-4 text-gray-700 flex items-center gap-4">
                <button
                  className="text-blue-500 hover:underline flex items-center gap-1"
                  onClick={() =>
                    navigate(`/new/setup/warehouse/${location.id}`)
                  }
                >
                  <FaEdit />
                  Edit
                </button>
                <button
                  className="text-red-500 hover:underline flex items-center gap-1"
                  onClick={() => handleDeleteClick(location)}
                >
                  <FaTrash />
                  Delete
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>

      {/* Delete Confirmation Modal */}
      {isModalOpen && (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
          <div className="bg-white rounded-lg p-6 w-1/3">
            <h2 className="text-lg font-semibold text-gray-800 mb-4">
              Confirm Deletion
            </h2>
            <p className="text-gray-600 mb-6">
              Are you sure you want to delete{" "}
              <span className="font-bold">
                {locationToDelete.pharmacy_name}
              </span>
              ?
            </p>
            <div className="flex justify-end gap-4">
              <button
                className="px-4 py-2 bg-gray-300 rounded text-gray-800 hover:bg-gray-400"
                onClick={closeModal}
              >
                Cancel
              </button>
              <button
                className="px-4 py-2 bg-red-500 text-white rounded hover:bg-red-600"
                onClick={confirmDelete}
              >
                {mutation.isLoading ? <CuSpinner /> : "Delete"}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default LocationTable;
